import "./style.scss";

import Search from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";

import StyledTextField from "../StyledTextField/StyledTextField";

export interface SearchBar {
    filter: string;
    onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    style?: React.CSSProperties;
    borderless?: boolean;
}

const borderlessSx = {
    "&.MuiTextField-root .MuiOutlinedInput-root": {
        height: "1.15rem",
        fontSize: "0.75rem",
        paddingRight: "4px",
        "& > fieldset": { border: "none" },
        "&:hover > fieldset": { border: "none" },
        "&.Mui-focused > fieldset": { border: "none" },
        ".MuiOutlinedInput-input": {
            padding: "2px 0 2px 0 !important",
            fontSize: "0.75rem",
            "&::placeholder": { fontSize: "0.75rem" },
        },
    },
};

const SmallSearchBar = ({ filter, onSearch, placeholder, style, borderless }: SearchBar) => {
    const [t] = useTranslation();
    const iconSize = borderless ? "0.85rem" : "1.2rem";

    return (
        <StyledTextField
            className="small-search-bar"
            value={filter}
            onChange={onSearch}
            placeholder={placeholder ? placeholder : t("Management.Search")}
            InputProps={{
                endAdornment: <Search sx={{ color: "#A8A8A8", fontSize: iconSize }} />,
            }}
            style={style}
            sx={borderless ? borderlessSx : undefined}
        />
    );
};

export default SmallSearchBar;
